import { Type } from 'class-transformer';

export class BaseWorkflowSearchResultDto {
    managementCompany: string;
    communityId: number;
    community: string;
    location: string;
    workFlowId: number;
    workFlowName: string;
    workOrders: string;
    invoiceNumber: string;

    @Type(() => Date)
    invoiceDate: Date;

    @Type(() => Date)
    datePosted: Date;

    invoiceAmount: number;
    workflowStatus: string;
    paymentStatus: string;
    accountNumber: string;
    invoiceStatus: string;
    hasNotes: boolean;
    hasBoardNotes: boolean;

    managementCompanyId: number;
}
